import { makeStyles, } from '@material-ui/core/styles';
import {
    badgeShoppingCartBackground, badgeShoppingCartColor,
} from 'styles/abstract/variables';

export const makeBadgeStyles = makeStyles({
    badge: {
        background: badgeShoppingCartBackground,
        color: badgeShoppingCartColor,
        border: `1px solid ${badgeShoppingCartColor}`,
    },

    anchorOriginBottomRightCircle: {
        right: '27%',
        bottom: '24%',
    },
}, { index: 1, });
